var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-skeleton-loader',[_c('rect',{attrs:{"y":"5","width":"400","height":"30","rx":"2","ry":"2"}}),_vm._v(" "),_c('rect',{attrs:{"y":"50","width":"400","height":"80","rx":"2","ry":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }